import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["systemValue", "eye", "eyeSlash"]

  connect() {
    this.toggle();
  }

  toggle() {
    const reconciled = this.data.get("reconciled") === "true"
    this.systemValueTargets.forEach(el => el.classList.toggle("d-none", !reconciled))
    this.eyeTargets.forEach(el => el.classList.toggle("d-none", !reconciled))
    this.eyeSlashTargets.forEach(el => el.classList.toggle("d-none", reconciled))
  }
}
